/**
 * User-facing Spanish copy for per-platform suggestion generation jobs.
 * Priority: completed / failed first, then pending, then phase while running.
 * @param {'google'|'meta'} platform
 * @param {object} payload — job-status API shape (may be partial)
 */
export function getOptimizationJobUILabel(platform, payload) {
  const { status, phase, suggestions_count: suggestionsCount, result } = payload || {};

  if (status === 'failed') {
    return platform === 'google'
      ? 'Error al analizar Google Ads'
      : 'Error al analizar Meta Ads';
  }

  if (status === 'completed') {
    const n = result?.total_suggestions_created;
    const num = typeof n === 'number' ? n : parseInt(String(n), 10);
    const safeN = Number.isFinite(num) ? num : 0;
    if (platform === 'google') {
      return safeN === 0
        ? 'Google Ads completado — sin nuevas optimizaciones'
        : `Google Ads completado — ${safeN} optimizaciones generadas`;
    }
    return safeN === 0
      ? 'Meta Ads completado — sin nuevas optimizaciones'
      : `Meta Ads completado — ${safeN} optimizaciones generadas`;
  }

  if (status === 'pending') {
    return platform === 'google'
      ? 'Preparando análisis de Google Ads...'
      : 'Preparando análisis de Meta Ads...';
  }

  const hasCount =
    suggestionsCount != null && suggestionsCount !== '' && Number.isFinite(Number(suggestionsCount));

  if (platform === 'google') {
    if (phase === 'fetching_data') return 'Obteniendo datos de Google Ads...';
    if (phase === 'evaluating') return 'Evaluando campañas de Google...';
    return 'Preparando análisis de Google Ads...';
  }

  if (phase === 'fetching_data') return 'Obteniendo datos de Meta Ads...';
  if (phase === 'simple_rules_complete') {
    return hasCount
      ? `Reglas básicas completadas — ${suggestionsCount} optimizaciones encontradas`
      : 'Reglas básicas completadas';
  }
  if (phase === 'complex_rules_complete') {
    return hasCount
      ? `Análisis avanzado completado — ${suggestionsCount} optimizaciones encontradas`
      : 'Análisis avanzado completado';
  }
  if (phase === 'diagnostics_complete') {
    return hasCount
      ? `Diagnóstico completado — ${suggestionsCount} optimizaciones encontradas`
      : 'Diagnóstico completado';
  }
  if (phase === 'enrichment_complete') {
    return hasCount
      ? `Enriquecimiento completado — ${suggestionsCount} optimizaciones encontradas`
      : 'Enriquecimiento completado';
  }

  return 'Preparando análisis de Meta Ads...';
}

/** @param {'google'|'meta'} platform */
export function getRowVisualState(platform, payload, ttlExpired) {
  const { status } = payload || {};
  if (ttlExpired) return 'done';
  if (status === 'failed') return 'error';
  if (status === 'completed') return 'done';
  return 'loading';
}
